/* eslint-disable @typescript-eslint/no-explicit-any */
import { getStorage, setStorage, StorageTypes } from '@helpers/storage';

interface AiSearchState { accepted: boolean; enabled: boolean }

const userId = (): string | undefined => (window as any).BFG?.currentUser?.user_id;

// Logged-in preference is per user in localStorage. Without a user id, never write the
// shared `aiSearch_anon` localStorage key (shared-browser leak); keep it tab-scoped.
const key = (): string => `aiSearch_${userId() || 'anon'}`;
const storageType = (): StorageTypes => (userId() ? StorageTypes.Local : StorageTypes.Session);

export const getAiSearch = (): AiSearchState => {
  const v = getStorage<AiSearchState>(storageType(), key());
  return { accepted: !!v?.accepted, enabled: !!v?.enabled };
};

export const setAiSearch = (patch: Partial<AiSearchState>): void => {
  setStorage(storageType(), key(), { ...getAiSearch(), ...patch });
};

export const semanticSearchFeature = (): boolean => (
  !!((window as any).BFG?.hasFeature?.('semantic_search')
    || (window as any).BFG?.context?.hasFeature?.('semantic_search'))
);

export const userNlsEnabled = (): boolean => !!(window as any).BFG?.currentUser?.nlsEnabled;

export const isAiSearchOn = (): boolean => semanticSearchFeature() && userNlsEnabled() && getAiSearch().enabled;
